var ContentDefinition = (function () {
    function ContentDefinition() {
        this.content = {};
    }
    Object.defineProperty(ContentDefinition.prototype, "end", {
        get: function () {
            return this.content;
        },
        enumerable: true,
        configurable: true
    });
    ContentDefinition.prototype.pageBreak = function (brk) {
        this.content.pageBreak = brk;
        return this;
    };
    ContentDefinition.prototype.pageOrientationAndBreak = function (orientation, brk) {
        this.content.pageOrientation = orientation;
        this.content.pageBreak = brk;
        return this;
    };
    ContentDefinition.prototype.headlineLevel = function (data) {
        this.content.headlineLevel = data;
        return this;
    };
    ContentDefinition.prototype.id = function (id) {
        this.content.id = id;
        return this;
    };
    return ContentDefinition;
}());
export { ContentDefinition };
